import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TwoImageOverlap = ({
  children,
  image1,
  image2,
  overlapX,
  overlapY,
  reversed,
  width,
  ...otherProps
}) => {
  return (
    <MainDiv width={width} reversed={reversed} {...otherProps}>
      <Image1Div reversed={reversed}>{image1}</Image1Div>
      <Image2Div reversed={reversed} overlapX={overlapX} overlapY={overlapY}>
        {image2}
      </Image2Div>
    </MainDiv>
  );
};

TwoImageOverlap.propTypes = {
  width: PropTypes.string,
};

TwoImageOverlap.defaultProps = {
  width: '100%',
  overlapX: 0,
  overlapY: 0,
};

const MainDiv = styled.div`
  width: ${props => props.width};
  position: relative;

  padding-left: 0;
  padding-right: 0;

  @media (max-width: 991px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const Image1Div = styled.div`
  z-index: 10;
  width: auto;
  width: 70%;
  margin-left: ${props => (props.reversed ? '0' : '30%')};
  text-align: ${props => (props.reversed ? 'left' : 'right')};

  img {
    width: 100%;
  }

  @media (max-width: 991px) {
    text-align: left;
    margin-left: 0;
    width: 60%;
    margin-top: 50px;
    position: absolute;
  }

  @media (max-width: 575px) {
    position: relative;
    width: 100%;
    margin-top: 10px;
  }
`;

const Image2Div = styled.div`
  text-align: ${props => (props.reversed ? 'right' : 'left')};
  z-index: 20;
  position: relative;
  margin-top: ${props => props.overlapY - 50}px;
  margin-left: ${props => (props.reversed ? '20%' : '0')};
  width: auto;
  width: 80%;

  img {
    width: 100%;
  }

  @media (max-width: 991px) {
    text-align: right;
    width: 50%;
    margin-left: 50%;
    margin-top: 0;
  }

  @media (max-width: 575px) {
    position: relative;
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
  }
`;

export default TwoImageOverlap;
